import httpClient from 'shared/lib/httpClient';
import { parseCurrencyList } from '../schemas/MasterDataSchema';

export const getCurrencyList = async (params, signal) => {
  const response = await httpClient.get('/currencies', { params, signal });
  return parseCurrencyList(response?.data);
};
